import { render } from "./updateOrder.vue?vue&type=template&id=ea07f738"
import script from "./updateOrder.vue?vue&type=script&lang=js"
export * from "./updateOrder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/vokaladezful-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__